import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Check } from "@phosphor-icons/react";

// Actions
import { closeAlertMessage } from "../redux/ui";

const HeaderStep = (props) => {
  const dispatch = useDispatch();
  const {
    currentIndex,
    url,
    isDisabled,
    currentPage,
    colors,
    text,
    classLabel,
  } = props;
  const currentIndexCorrected = currentIndex + 1;

  const getColors = () => {
    let backgroundColor, color, borderColor;

    backgroundColor =
      currentPage >= currentIndexCorrected
        ? colors.main_color
        : colors.background_color;
    color =
      currentPage >= currentIndexCorrected
        ? colors.main_buttons_text_color
        : colors.text_color;
    borderColor = colors.main_color;

    return { backgroundColor, color, borderColor };
  };

  const { backgroundColor, color, borderColor } = getColors();

  const HeaderStepBody = (
    <div className="link-step">
      <div
        className={
          "numberCircle " +
          `${currentPage < currentIndexCorrected ? "future-page-number" : ""} ${
            currentPage > currentIndexCorrected ? "past-page-number" : ""
          }`
        }
        style={{
          backgroundColor,
          color,
          borderColor,
          border:
            currentPage > currentIndexCorrected
              ? 0
              : `1px solid ${borderColor}`,
        }}
      >
        {currentPage > currentIndexCorrected ? (
          <Check />
        ) : (
          currentIndexCorrected
        )}
      </div>
      <span className={"link-label" + `${classLabel ? "-" + classLabel : ""}`}>
        {text}
      </span>
    </div>
  );

  const HeaderStepBodyLink = (
    <div className="link-step">
      <Link
        to={url || "/#"}
        onClick={() => dispatch(closeAlertMessage())}
        style={{ color: colors.main_color }}
        className="z-index-2"
      >
        <div
          className={
            "numberCircle " +
            `${
              currentPage < currentIndexCorrected ? "future-page-number" : ""
            } ${currentPage > currentIndexCorrected ? "past-page-number" : ""}`
          }
          style={{
            backgroundColor,
            color,
            borderColor,
            border: currentPage > currentIndexCorrected ? 0 : "1px solid",
          }}
        >
          {currentPage > currentIndexCorrected ? (
            <Check />
          ) : (
            currentIndexCorrected
          )}
        </div>
        <span
          className={"link-label" + `${classLabel ? "-" + classLabel : ""}`}
        >
          {text}
        </span>
      </Link>
    </div>
  );

  return (
    <Fragment>
      {isDisabled ? (
        <div className="numberCircle disabledLink">{currentIndexCorrected}</div>
      ) : currentPage > currentIndexCorrected ? (
        HeaderStepBodyLink
      ) : (
        HeaderStepBody
      )}
    </Fragment>
  );
};

export default HeaderStep;
